import BMI from "../assets/images/BMI_mark.svg";
import uric from "../assets/images/uric_mark.svg";
import heart from "../assets/images/heart_mark.svg";
import pressure from "../assets/images/blood_pressure_mark.svg";
import fat from "../assets/images/blood_fat_mark.svg";
import sugar from "../assets/images/blood_sugar_mark.svg";
import c_image from "../assets/images/chinese_medicine_image.svg";
import w_image from "../assets/images/western_medicine_image.svg";

const cards = {
  healthyData: [
    {
      dict_id: 2,
      name: "体重指数 (BMI)",
      title: "体重指数 (BMI)",
      icon: BMI,//图标
      key: "bmi",
      unit: "",//单位
      show: ["bmi_index"],//需要在首页展示的字段
      showItem: { bmi_index: "BMI" },
      reference: {//参考数据
        name: "体重指数(BMI)",
        standard: [
          { key: "偏瘦", value: "<18.5    " },
          { key: "正常", value: "18.5~23.9" },
          { key: "偏胖", value: "24~26.9  " },
          { key: "肥胖", value: "27~29.9  " },
          { key: "重度肥胖", value: "≥30" },
        ]
      }
    }, {
      dict_id: 3,
      name: "血压数据",
      title: "血压",
      icon: pressure,
      unit: "mmHg",
      key: "blood_pressure",
      show: ["blood_pressure_di", "blood_pressure_gao"],
      showItem: { blood_pressure_di: "收缩压", blood_pressure_gao: "舒张压" },
      reference: {
        name: "血压指数",
        standard: [
          { key: "正常:", value: "收缩压:#90～140mmHg@舒张压:#60～90mmHg" },
          { key: "偏高:", value: "收缩压:#≥140mmHg@舒张压:#≥90mmHg" },
          { key: "偏低:", value: "收缩压:#≤90mmHg@舒张压:#≤60mmHg" },
        ]
      }
    }, {
      dict_id: 4,
      name: "血糖数据",
      title: "血糖",
      icon: sugar,
      unit: "mmol/L",
      key: "blood_sugar",
      show: ["blood_sugar_hour", "blood_sugar_kong"],
      showItem: { blood_sugar_kong: "空腹", blood_sugar_hour: "餐后" },
      reference: {
        name: "血糖指数",
        standard: [
          { key: "正常:", value: "空腹:#3.92～6.16mmol/L@餐后:#5.1~7.0mmol/L" },
          { key: "偏高:", value: "空腹:#≥6.16mmol/L@餐后:#≥7.0mmol/L" },
          { key: "偏低:", value: "空腹:#≤3.92mmol/L@餐后:#≤5.1mmol/L" },
        ]
      }
    }, {
      dict_id: 5,
      name: "血脂数据",
      title: "血脂",
      icon: fat,
      unit: "mmol/L",
      key: "blood_fat",
      show: ["blood_fat_zong"],
      showItem: { blood_fat_zong: "总胆固醇" },
      reference: {
        name: "血脂指数",
        standard: [
          { key: "正常:", value: "总胆固醇2.8～5.17mmol/L" },
          { key: "偏高:", value: "总胆固醇≥5.17mmol/L" },
          { key: "偏低:", value: "总胆固醇≤2.8mmol/L" },
        ]
      }
    }, {
      dict_id: 6,
      name: "尿酸数据",
      title: "尿酸",
      icon: uric,
      unit: "µmol/L",
      key: "uric_acid",
      show: ["uric_acid_num"],
      showItem: { uric_acid_num: "尿酸" },
      reference: {
        name: "尿酸指数 （尿酸酶—过氧化物酶偶联法）",
        standard: [
          { key: "正常:", value: "尿酸90～420umol/L" },
          { key: "偏高:", value: "尿酸≥420umol/L" },
          { key: "偏低:", value: "尿酸≤90umol/L" },
        ]
      }
    }, {
      dict_id: 7,
      name: "心率数据",
      title: "心率",
      icon: heart,
      unit: "pbm",
      key: "heart_rate",
      show: ["heart_rate_num"],
      showItem: { heart_rate_num: "心率" },
      reference: {
        name: "心率指数",
        standard: [
          { key: "正常:", value: "60~100次/分" },
          { key: "偏高:", value: "≥100次/分" },
          { key: "偏低:", value: "≤60次/分" },
        ]
      }
    },
  ],
  healthyInfo: [
    {
      name: "中医健康档案",
      image: c_image,
    },
    {
      name: "西医体检报告",
      image: w_image
    }
  ],
  visionHealthInfo: [
    {
      key: "naked_vision",
      name: "裸眼视力",
      dict_id: 31
    }, {
      key: "glasses_degree",
      name: "眼镜度数",
      dict_id: 32
    }, {
      key: "astigmatism_degree",
      name: "眼睛散光",
      dict_id: 33
    }, {
      key: "intraocular_pressure_symptoms",
      name: "眼压mmHg",
      dict_id: 34
    }, {
      key: "dry_eye",
      name: "眼干症状",
      dict_id: 216
    }, {
      key: "symptoms_of_eye",
      name: "眼痛症状",
      dict_id: 217,
    }, {
      key: "eyestrain",
      name: "视力疲劳",
      dict_id: 218,
    }
  ],//视力健康
  familyHealthHistory: [
    {
      name: "家族史",
      id: 9,
    }, {
      name: "疾病史",
      id: 10,
    }, {
      name: "过敏史",
      id: 11,
    }, {
      name: "用药史",
      id: 12,
    }, {
      name: "手术史",
      id: 13,
    }, {
      name: "吸烟史",
      id: 14,
    }, {
      name: "饮酒史",
      id: 15,
    }
  ],//健康史
};
export default cards;
